<template>
  <div class="renderPage pa-4 pb-16">
  <v-card flat class="overflow-hidden ba-card">
    <!-- CABECERA -->
    <v-toolbar flat height="56" style="background-color:#37474f !important" dark>
      <v-icon class="mr-3">mdi-package-variant-closed</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.9rem">
        Seleccionar Artículos
      </v-toolbar-title>
      <div class="ml-3 caption" style="opacity:0.7">Busca y agrega productos a la factura</div>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- CONTENIDO INTEGRADO -->
    <v-card-text class="pa-6">
      <div class="d-flex align-center mb-4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="¿Qué artículo buscas hoy?"
          placeholder="Nombre, código o cabys..."
          outlined
          dense
          hide-details
          class="flex-grow-1 ba-search"
          autofocus
          @keyup.enter="focusFirstRow"
        ></v-text-field>
        <v-btn
          style="background-color:#37474f !important;border-radius:4px"
          dark
          depressed
          class="font-weight-bold ml-4"
          height="40"
          @click="getData()"
          :loading="loading"
        >
          <v-icon left>mdi-refresh</v-icon>
          Refrescar
        </v-btn>
      </div>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="ba-table clickable-rows"
        :items-per-page="10"
        :loading="loading"
        loading-text="Cargando artículos..."
        @click:row="handleRowClick"
      >
        <template v-slot:[`item.codigo`]="{ item }">
          <span class="code-chip">{{ item.codigo }}</span>
        </template>

        <template v-slot:[`item.nombre`]="{ item }">
          <div class="d-flex flex-column py-2">
            <span class="font-weight-bold text-body-1 mb-0">{{ item.nombre }}</span>
            <span class="caption grey--text">{{ item.cabys || 'Sin Cabys' }}</span>
          </div>
        </template>

        <template v-slot:[`item.monto`]="{ item }">
          <div class="d-flex flex-column align-end">
            <span class="font-weight-bold price-text text-h6">{{ item.monto | currency }}</span>
            <span class="caption grey--text">Costo: {{ (item.costo || 0) | currency }}</span>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <!-- QUICK ADD INPUTS -->
          <div class="d-flex align-center justify-end" v-if="quickAdd">
            <v-text-field
              v-model.number="item._qty"
              type="number"
              placeholder="Cant."
              dense
              hide-details
              outlined
              rounded-lg
              class="quick-input-field mr-2"
              @focus="$event.target.select()"
              @click.stop
            ></v-text-field>
            <v-text-field
              v-model.number="item._cost"
              type="number"
              placeholder="Costo"
              dense
              hide-details
              outlined
              rounded-lg
              prefix="₡"
              class="quick-input-field-large mr-2"
              @focus="$event.target.select()"
              @click.stop
            ></v-text-field>
            <v-btn
              style="background-color:#37474f !important;border-radius:4px"
              dark
              depressed
              small
              height="40"
              class="font-weight-bold"
              @click.stop="addToCart(item)"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
          <v-btn
            v-else
            style="background-color:#37474f !important;border-radius:4px"
            dark
            depressed
            class="text-none font-weight-bold px-6"
            @click.stop="handleRowClick(item)"
          >
            Seleccionar
          </v-btn>
        </template>

        <template v-slot:no-data>
          <div class="pa-10 text-center">
            <v-icon size="80" color="grey lighten-2" class="mb-4">mdi-package-variant-closed-remove</v-icon>
            <p class="grey--text text-h6">No encontramos lo que buscas</p>
            <v-btn style="background-color:#37474f !important;border-radius:4px" dark depressed text @click="getData()">Reintentar búsqueda</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>

    <!-- FOOTER PARA MULTI-ADD -->
    <v-fade-transition v-if="quickAdd && addedCount > 0">
      <v-card
        class="fixed-bottom mx-auto rounded-xl elevation-10 pa-4 d-flex align-center"
        style="background-color:#37474f !important"
        max-width="400"
      >
        <v-badge color="error" :content="addedCount" offset-x="10" offset-y="10">
          <v-icon color="white" large>mdi-cart-check</v-icon>
        </v-badge>
        <div class="ml-4">
          <div class="font-weight-bold title white--text">Artículos añadidos</div>
          <div class="caption white--text opacity-70">Continúa agregando o cierra para ver el detalle</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn depressed color="white" light style="border-radius:4px" class="font-weight-bold px-6" @click="close()">
          Listos
        </v-btn>
      </v-card>
    </v-fade-transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  props: {
    allwedOnly: {
      type: Boolean,
      default: true,
    },
    // Nuevas propiedades para mejorar el flujo
    quickAdd: {
      type: Boolean,
      default: false,
    }
  },
  filters: {
    currency(val) {
      if (!val) return '₡0';
      return new Intl.NumberFormat('es-CR', { style: 'currency', currency: 'CRC' }).format(val);
    }
  },
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        { text: "Código", value: "codigo", sortable: true, width: 90 },
        { text: "Artículo", value: "nombre", sortable: true },
        { text: "Precio Venta", value: "monto", sortable: true, align: 'right', width: 120 },
        { text: "Cant. / Costo", value: "actions", width: 280, sortable: false, align: 'right' },
      ],
      items: [],
      addedCount: 0,
    };
  },

  computed: {
    ...mapGetters(["strCia"]),
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.loading = true;
      axios
        .get("api/Articulos/getArticulosByCompany?cia=" + this.strCia)
        .then((response) => {
          this.items = response.data.map(item => ({
            ...item,
            _qty: 1,
            _cost: item.costo || 0,
            _price: item.monto || 0
          }));
        })
        .catch((error) => console.error(error))
        .finally(() => { this.loading = false; });
    },

    addToCart(item) {
      if (!item._qty || item._qty <= 0) return;
      
      this.$emit("quick-add", {
        item: Object.assign({}, item),
        qty: item._qty,
        cost: item._cost,
        price: item._price
      });
      
      this.addedCount++;
    },

    handleRowClick(item) {
      if (!this.quickAdd) {
         this.$emit("clicked", Object.assign({}, item));
      }
    },

    close() {
      this.$emit("closed");
    },
    
    focusFirstRow() {
      // Logic to focus first row could go here
    }
  },
};
</script>

<style scoped>
.ba-card {
  border-radius: 4px !important;
}

/* Search input */
.ba-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* Quick add inputs */
.quick-input-field >>> .v-input__slot,
.quick-input-field-large >>> .v-input__slot {
  border-radius: 4px !important;
}

.ba-table { background: transparent !important; }
.ba-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.06em;
  border-bottom: none !important;
  height: 48px !important;
}
.theme--dark .ba-table >>> thead th {
  background-color: #263238 !important;
  color: #cfd8dc !important;
}

.clickable-rows >>> tbody tr {
  cursor: pointer;
}

.clickable-rows >>> tbody tr:hover { 
  background-color: rgba(55, 71, 79, 0.06) !important; 
}

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.theme--dark .border-light { border: 1px solid rgba(255, 255, 255, 0.1) !important; }

.quick-input-field { width: 65px !important; flex: none !important; }
.quick-input-field-large { width: 110px !important; flex: none !important; }
.quick-input-field >>> input, .quick-input-field-large >>> input { 
  text-align: center; 
  font-weight: bold; 
  padding: 0 !important;
}
.quick-input-field >>> .v-input__control, .quick-input-field-large >>> .v-input__control {
  min-height: 40px !important;
}
.theme--dark .quick-input-field >>> fieldset, 
.theme--dark .quick-input-field-large >>> fieldset {
  border-color: rgba(255,255,255,0.2) !important;
}

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.theme--dark .border-light { border: 1px solid rgba(255, 255, 255, 0.1) !important; }

.fixed-bottom {
  position: fixed;
  bottom: 32px;
  left: 0;
  right: 0;
  z-index: 100;
  border: 4px solid rgba(255,255,255,0.2) !important;
}

.line-height-1 { line-height: 1.2; }
.opacity-70 { opacity: 0.7; }
.height-auto { height: auto !important; }

/* Precio adaptable claro/oscuro */
.price-text { color: #1e293b !important; }
.theme--dark .price-text { color: #f1f5f9 !important; }
</style>